export type NormalizedRole = 'staff' | 'customer_success' | 'designer' | 'redactor' | 'user'

export function normalizeRole(input: unknown): NormalizedRole {
  const raw = typeof input === 'string' ? input : ''
  const s = raw.trim().toLowerCase()

  // Common aliases / legacy values
  if (s === 'admin' || s === 'administrator') return 'staff'
  if (s === 'cs' || s === 'customer success' || s === 'customersuccess' || s === 'customer-success')
    return 'customer_success'
  if (s === 'customer_success') return 'customer_success'
  if (s === 'designer') return 'designer'
  if (s === 'redactor' || s === 'editor') return 'redactor'
  if (s === 'staff') return 'staff'
  if (s === 'user') return 'user'

  // Fallback (safe default)
  return 'user'
}


